import React, { useEffect, useState } from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import InLineStatusSelectComponent from "../../common/inline-edit/component/InLineStatusSelectComponent"
import { GlobalHelper } from "../../indexImports"
import { generateOptions } from "../../quote/utils/QuoteStatus"
import IntlProps from "../../state/helpers/IntlProps"
import { SelectOption } from "../../state/helpers/SelectOption"

type OwnProps = {
    docGeneratedStatus: string
    onStatusChange: (string, actionId) => void
    options : SelectOption[]
}
const QuoteStatusSelectComponent = (props: OwnProps & IntlProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(true)
    useEffect(() => {
        (async () => {
            setIsLoading(false)
        })()
    }, [])

    const docGeneratedStatus = generateOptions(props.intl).find(i => i.value === props.docGeneratedStatus) as SelectOption

    return (
        <>
            { !GlobalHelper.hasGolfIntegration() &&
                <label className="col-12 col-form-label custom-form-label">
                    <FormattedMessage
                        id="price_list.edit.details.default_quote_status_label"
                        defaultMessage="Default Quote Status"
                    />
                </label>
            }
            <div className="col-12">
                {!isLoading && !GlobalHelper.hasGolfIntegration() &&
                    <InLineStatusSelectComponent 
                        name="price-list-status-select"
                        id="price-list-status-select"
                        type="quote"
                        title={docGeneratedStatus.label as string}
                        value={docGeneratedStatus}
                        options={props.options}
                        onChange={(option, actionId) => props.onStatusChange(option, actionId)}
                    />
                }
            </div>

        </>
    )
}


export default injectIntl(QuoteStatusSelectComponent)


// WEBPACK FOOTER //
// ./src/price-list/components/QuoteStatusSelectComponent.tsx